import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Pill } from './Pill';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-blush py-10 sm:py-12" aria-labelledby="faq-heading" data-id="element-33" data-mp="1gjc0fofmch2q">
      <div className="mx-auto max-w-3xl px-6" data-id="element-34" data-mp="1glgbqrfukid1">
        <div className="text-center" data-id="element-35" data-mp="24a94yg534c3y">
          <Pill data-id="element-36" data-mp="24ban14kipyv6">Before you decide</Pill>
          <h2 id="faq-heading" className="mt-5 font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-37" data-mp="28bb652ikay8k">
            Frequently asked questions
          </h2>
        </div>

        <ul className="mt-9 space-y-3" data-id="element-38" data-mp="1zihhwfl50oik">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-2xl border bg-cream transition-colors duration-150 ease-out ${isOpen ? 'border-gold/60' : 'border-rose-deep/20'}`} data-id="element-39" data-mp="2n70sx2vknfec" data-mpi={index}>
                <h3 data-id="element-40" data-mp="14v0sgt23to5n">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-2xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wine" data-id="element-41" data-mp="14wbxsxb773yv">
                    <span className="font-display text-xl leading-snug text-charcoal" data-id="element-42" data-mp="19sajgd5567vl">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-wine text-cream' : 'bg-rose-light text-wine'}`} aria-hidden="true" data-id="element-43" data-mp="1jj53daux0vdv">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-44" data-mp="1slecbwajcgp5" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-45" data-mp="3udsv0xkwlp6m">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} key="panel" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-46" data-mp="1y9whcxq36niz">
                      <p className="px-6 pb-6 font-sans text-[0.95rem] leading-relaxed text-ash" data-id="element-47" data-mp="2h5uzqmtcp7ct">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}